module.exports = __webpack_public_path__ + "static/img/Christian-Salem.ea75a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Christian-Salem.jpg
// module id = GZ5z
// module chunks = 0